import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import EnableDisableModal from "../../../components/modals/enableDisableModal";
import EnabledDisabledPopUp from "../../../components/popups/EnabledDisabledPopUp";
import { enableDisableDistributor } from "../../../redux/actions/distributorActions";
import ErrorPopup from "../../../components/popups/ErrorPopup";
import TableSendMailModal from "../../../components/modals/Distributor/send-mail-table-modal";

const DistributorOnboardningTableData = ({
  data,
  index,
  distributorListFunc,
  is_subscribed,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [enabledDisable, setEnabledDisable] = useState(false);
  const [onEnableShow, setOnEnableShow] = useState(false);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState("");
  const [sendMailShow, setSendMailShowShow] = useState(false);

  const [userData, setUserData] = useState(null);
  const user_type = localStorage.getItem("userType");
  useEffect(() => {
    if (user_type === "super_user") {
      const permissionData = JSON.parse(localStorage.getItem("permissions"));
      const permissionValue = permissionData?.find(
        (item) => item?.module_name === "Distributor" && item
      );

      setUserData(permissionValue);
    }
  }, []);

  const enableDisableFunc = (distributor_id) => {
    console.log(distributor_id);
    dispatch(
      enableDisableDistributor(
        distributor_id,
        onEnableDisableSuccess,
        onEnableDisableError
      )
    );
  };

  const onEnableDisableSuccess = (data) => {
    console.log(data);
    setOnEnableShow(false);

    setEnabledDisable(true);

    const timeOutFnc = () => {
      setEnabledDisable(false);
      distributorListFunc();
    };

    setTimeout(timeOutFnc, 2000);
  };

  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  };

  const onEnableDisableError = (err) => {
    console.log(err);
    setShowErrorPopup(true);
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
  };

  return (
    <tr className="table-rows1">
      <td className="table-each-row-data">{index + 1}</td>
      <td className="table-each-row-data">
        {data?.distributor_id ? data?.distributor_id : "--"}
      </td>
      <td className="table-each-row-data">
        {data?.firm_name
          ? data?.firm_name.charAt(0).toUpperCase() + data?.firm_name.slice(1)
          : "--"}
      </td>
      {/* <td className="table-each-row-data">
        {data?.state?.name ? data?.state?.name : "--"}
      </td>
      <td className="table-each-row-data">
        {data?.city?.name ? data?.distributor?.city?.name : "--"}
      </td> */}
      {/* <td className="table-each-row-data">
        {data?.distributor?.distributorDivision?.vendorDivision?.name}
      </td> */}
      <td className="table-each-row-data">
        {data?.mobile ? data?.mobile : "--"}
      </td>
      <td className="table-each-row-data">
        {data?.email ? data?.email : "--"}
      </td>

      {data?.status ? (
        <td className="table-each-row-data color-green">Active</td>
      ) : (
        <td className="table-each-row-data color-danger">Inactive</td>
      )}
      {(user_type == "super_user" && userData?.write) ||
      user_type == "vendor" ? (
        <>
          {is_subscribed == "false" && (
            <>
              {data?.mail_sent == true ? (
                <td className="table-each-row-data text_green">
                  <span className="fw_700 px-2">SENT</span>
                </td>
              ) : (
                <td className="table-each-row-data text_red">
                  <button
                    className="send-mail-btn"
                    onClick={() => setSendMailShowShow(true)}
                    disabled={data?.status == "draft"}
                  >
                    Send Mail
                  </button>
                </td>
              )}
            </>
          )}
        </>
      ) : (
        <>
          {is_subscribed == "false" && (
            <>
              {data?.mail_sent == true ? (
                <td className="table-each-row-data text_green">
                  <span className="fw_700 px-2">SENT</span>
                </td>
              ) : (
                <td className="table-each-row-data text_red">
                  <button className="send-mail-btn" disabled>
                    Send Mail
                  </button>
                </td>
              )}
            </>
          )}
        </>
      )}

      <td className="table-each-row-data">
        <div className="all-button">
          <button
            className="button-view"
            type="button"
            onClick={() => navigate(`/distributors/onboarding/view/${data.id}`)}
          >
            {"view"}
          </button>

          {(user_type == "super_user" && userData?.write) ||
          user_type == "vendor" ? (
            <>
              <span className="vr  vr_line mt-1 "></span>
              {data?.status ? (
                <button
                  className="button-disable"
                  type="button"
                  // bgColor={"red"}
                  color={"green"}
                  onClick={() => setOnEnableShow(true)}
                >
                  DISABLE
                </button>
              ) : (
                <button
                  className="button-enable"
                  type="button"
                  // bgColor={"red"}
                  color={"green"}
                  onClick={() => setOnEnableShow(true)}
                >
                  Enable
                </button>
              )}
            </>
          ) : (
            ""
          )}
        </div>
      </td>
      <EnableDisableModal
        show={onEnableShow}
        title={`Distributor`}
        handleClose={() => setOnEnableShow(false)}
        status={data?.status}
        id={data?.id}
        enableDisableFunc={enableDisableFunc}
      />
      <EnabledDisabledPopUp
        title={`Distributor - ${data?.distributor?.distributor_id}`}
        show={enabledDisable}
        status={data.status}
      />
      <ErrorPopup
        show={showErrorPopup}
        title={showErrorMsg}
        handleClose={closeErrorPopup}
      />
      <TableSendMailModal
        data={data}
        show={sendMailShow}
        distributorListFunc={distributorListFunc}
        handleClose={() => setSendMailShowShow(false)}
      />
    </tr>
  );
};

export default DistributorOnboardningTableData;
